import { ChangeDetectionStrategy, Component, inject, model, signal } from '@angular/core';
import { Button } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { AppNavigationService } from '../../../core/services';
import { LayoutService } from '../../../layout/layout.service';
import { SubscriberSelectComponent } from '../../subscriber/subscriber-select/subscriber-select.component';
import { UserSelectComponent } from '../../user/user-select/user-select.component';

@Component({
    selector: 'app-impersonation-dialog',
    imports: [Button, Dialog, SubscriberSelectComponent, UserSelectComponent],
    templateUrl: './impersonation-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ImpersonationDialogComponent {
    private appNavigationService = inject(AppNavigationService);
    private layoutService = inject(LayoutService);

    visible = model<boolean>(false);

    selectedSubscriberKey = signal<number | null>(null);
    selectedUserId = signal<string | null>(null);

    onShow() {
        this.selectedSubscriberKey.set(this.layoutService.activeSubscriberKey());
        this.selectedUserId.set(null);
    }

    onSubscriberKeyChanged(subscriberKey: number | null) {
        this.selectedSubscriberKey.set(subscriberKey);
        this.selectedUserId.set(null);
    }

    onUserIdChanged(userId: string | null) {
        this.selectedUserId.set(userId);
    }

    impersonate() {
        const userId = this.selectedUserId();

        if (!userId) {
            return;
        }

        this.appNavigationService.openImpersonationTab('/home', userId);
        this.close();
    }

    close() {
        this.visible.set(false);
    }
}
